import {
  AfterViewChecked,
  Component,
  CUSTOM_ELEMENTS_SCHEMA, Inject,
  Input,
  OnChanges, OnDestroy,
  OnInit, PLATFORM_ID,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import {IonButton, IonButtons, IonCol, IonIcon, IonImg, IonModal, IonRow} from '@ionic/angular/standalone';
import {YouTubePlayer} from '@angular/youtube-player';
import {Lightbox, LightboxModule} from 'ngx-lightbox';
import {addIcons} from 'ionicons';
import {logoYoutube, grid, close } from 'ionicons/icons';
import {LightgalleryModule} from 'lightgallery/angular';
import lgVideo from 'lightgallery/plugins/video';
import lgZoom from 'lightgallery/plugins/zoom';
import {DomSanitizer} from '@angular/platform-browser';
import {BeforeSlideDetail} from 'lightgallery/lg-events';
import {LightGallerySettings} from 'lightgallery/lg-settings';
import {LightGallery} from 'lightgallery/lightgallery';
import {CommonModule, isPlatformBrowser} from '@angular/common';


@Component({
  selector: 'app-property-image-gallery',
  templateUrl: './property-image-gallery.component.html',
  styleUrls: ['../property-page.component.scss', './property-image-gallery.component.scss'],
  imports: [
    IonButton,
    IonCol,
    CommonModule,
    IonIcon,
    IonImg,
    IonRow,
    LightboxModule,
    LightgalleryModule,
    YouTubePlayer,
    IonModal,
    IonButtons
  ],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None,
})
export class PropertyImageGalleryComponent  implements OnChanges, AfterViewChecked, OnDestroy {

  @Input() imagesList: any = [];
  @Input() videoUrl: string = '';
  @Input() name: string = '';
  @Input() propertyNumber: string = '';
  @Input() size: string = '';
  @Input() labelText: string = '';
  @Input() subCatName: any = '';
  @Input() isParent: boolean = false;
  _albums: Array<any> = [];
  videoId: string = '';
  propertyThumbs: any = [];


  // LightGallery settings
  get settingsGallery(): LightGallerySettings {
    if (!this.isBrowser) {
      return {};
    }
    return {
      counter: true,
      plugins: [lgZoom, lgVideo], // Include plugins here
      download: true,
      fullScreen: true,
      thumbnail: true,
      // Add other settings as needed
    };
  }

  private lightGalleryInstance!: LightGallery;
  private needRefresh = false;
  isBrowser: boolean;

  constructor(private _lightbox: Lightbox,
              private sanitizer: DomSanitizer,
            @Inject(PLATFORM_ID) private platformId: Object) {
    addIcons({grid,logoYoutube,close});
  this.isBrowser = isPlatformBrowser(this.platformId);
  }

  onInit = (detail: { instance: LightGallery }): void => {
    // Only assign the instance if we are in the browser
    if (this.isBrowser && detail?.instance) {
      this.lightGalleryInstance = detail.instance;
    }
  };
  settings = {
    // counter: false,
    plugins: [lgVideo],
  };
  onBeforeSlide = (detail: BeforeSlideDetail): void => {
    // Only log or interact if in the browser
    if (this.isBrowser && detail) {
      try {
        const { index, prevIndex } = detail;
        console.log('Before slide change:', { index, prevIndex });
      } catch (error) {
        console.warn('LightGallery slide change error:', error);
      }
    }
  };




  ngAfterViewChecked(): void {
    if (this.isBrowser && this.lightGalleryInstance && this.needRefresh) {
      try {
        this.lightGalleryInstance.refresh();
        this.needRefresh = false;
      } catch (error) {
        console.warn('LightGallery refresh error:', error);
        this.needRefresh = false;
      }
    }
  }

  ngOnDestroy(): void {
    // Crucial: Only destroy if in the browser AND the instance exists
    if (this.isBrowser && this.lightGalleryInstance) {
      try {
        this.lightGalleryInstance.destroy();
      } catch (error) {
        console.warn('LightGallery destroy error:', error);
      }
    }
  }

  driveUrl: any;
  ngOnChanges (changes: SimpleChanges) {
    console.log(this.videoUrl);
    if (changes['imagesList']) {
      if (this.imagesList && this.imagesList.length >= (this.videoUrl ? 3 : 4)) {
        this.propertyThumbs = this.imagesList.slice(0, (this.videoUrl ? 3 : 4));
        console.log(this.propertyThumbs);
      }
      if (this.imagesList) {
        this._albums = this.imagesList.map((img: any, index: number) => {
          return {
            src: img.filepath,
            caption: this.name ?? this.propertyNumber,
            thumb: img.filepath // Assuming the thumbnail is the same as the full image
          };
        });
        
        // Refresh LightGallery if instance exists
        if (this.isBrowser && this.lightGalleryInstance) {
          this.needRefresh = true;
        }
      }
      if (this.videoUrl && !this.videoUrl.includes('drive.google.com')) {
        this.videoId = this.getYoutubeVideoId(this.videoUrl);
        console.log(this.driveUrl);
      } else {
        this.isDrive = true;
        const rawUrl: any = this.convertDriveViewToEmbedUrl(this.videoUrl);
        this.driveUrl = this.sanitizer.bypassSecurityTrustResourceUrl(rawUrl);
      }
    }
  }
  driveVideoId: string = '';
  convertDriveViewToEmbedUrl(viewUrl: string): string | null {
    const regex = /https:\/\/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)\/view(?:\?usp=sharing)?/;
    const match = viewUrl.match(regex);

    if (match && match[1]) {
      const fileId = match[1];
      this.driveVideoId = fileId;
      return `https://drive.google.com/file/d/${fileId}/preview`;
    } else {
      // Handle cases where the input URL doesn't match the expected format
      console.warn('Invalid Google Drive view URL format:', viewUrl);
      return null;
    }
  }


  open(index: number): void {
    console.log('Opening gallery at index:', index);
    console.log('LightGallery instance:', this.lightGalleryInstance);
    console.log('Albums:', this._albums);
    
    // open lightbox using LightGallery
    if (this.isBrowser && this.lightGalleryInstance) {
      try {
        this.lightGalleryInstance.openGallery(index);
      } catch (error) {
        console.warn('LightGallery open error:', error);
        // fallback to ngx-lightbox
        this._lightbox.open(this._albums, index, {
          showImageNumberLabel: true,
          alwaysShowNavOnTouchDevices: true,
          plugins: [lgZoom],
          showZoom: true,
          fitImageInViewPort: true,
        });
      }
    } else {
      console.log('Using ngx-lightbox fallback');
      // fallback to ngx-lightbox
      this._lightbox.open(this._albums, index, {
        showImageNumberLabel: true,
        alwaysShowNavOnTouchDevices: true,
        plugins: [lgZoom],
        showZoom: true,
        fitImageInViewPort: true,
      });
    }
  }
  close(): void {
    // close lightbox programmatically
    this._lightbox.close();
  }
  isDrive: boolean = false;
  getYoutubeVideoId(url: string) {
    if (url.includes('youtu.be')) {
      let urlString = url.split('youtu.be/')[1];
      urlString = urlString.split('?')[0];
      console.log(urlString);
      return urlString;
    } else if (url.includes('youtube.com')) {
      const urlString = url.split('=')[1];
      console.log(urlString);
      return urlString;
    } else if (url.includes('drive.google.com')) {
      this.isDrive = true;
      return url;
    } else {
      return '';
    }
  }
}
